import { render } from "./logsView.vue?vue&type=template&id=3a0b5ee3&scoped=true"
import script from "./logsView.vue?vue&type=script&lang=js"
export * from "./logsView.vue?vue&type=script&lang=js"

import "./logsView.vue?vue&type=style&index=0&id=3a0b5ee3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a0b5ee3"]])

export default __exports__